// Formato de campos monetarios (separador de miles + decimales configurables).
// Los inputs nativos type="number" no soportan comas, por eso los campos de
// dinero usan type="text" con estas funciones para mostrar/leer el valor.

export function formatearMoneda(valor, decimales = 0) {
  if (valor === '' || valor === null || valor === undefined) return '';
  const numero = Number(valor);
  if (isNaN(numero)) return '';
  const [parteEntera, parteDecimal] = String(valor).split('.');
  const enteroFormateado = parteEntera.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  if (decimales > 0 && parteDecimal !== undefined) {
    return `${enteroFormateado}.${parteDecimal}`;
  }
  return enteroFormateado;
}

export function limpiarMoneda(texto, decimales = 0) {
  let limpio = (texto || '').replace(/,/g, '');
  if (decimales > 0) {
    limpio = limpio.replace(/[^\d.]/g, '');
    const partes = limpio.split('.');
    if (partes.length > 2) limpio = partes[0] + '.' + partes.slice(1).join('');
  } else {
    limpio = limpio.replace(/[^\d]/g, '');
  }
  return limpio;
}

// Valor sin comas para mostrar/editar mientras el campo está enfocado. A diferencia
// de limpiarMoneda (que limpia texto recién tecleado), esta parte de un valor ya
// guardado (a veces "50000.00" si la columna en BD es NUMERIC) y debe truncar la
// parte decimal en vez de concatenarla cuando decimales=0.
export function valorCrudo(valor, decimales = 0) {
  if (valor === '' || valor === null || valor === undefined) return '';
  const str = String(valor);
  return decimales > 0 ? str : str.split('.')[0];
}
